import {Component, HostListener, input, InputSignal, OnDestroy, OnInit, output, OutputEmitterRef} from '@angular/core';
import {AbstractControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {Subject, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {CommonModule} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CommonService} from '../../../services/common.service';

@Component({
  selector: 'app-text-input',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule
  ],
  templateUrl: './text-input.component.html',
  styleUrls: ['../styles.css', './text-input.component.css']
})
export class TextInputComponent {
  private readonly onDestroy: Subject<any> = new Subject<any>();

  label: InputSignal<any> = input('');
  type: InputSignal<any> = input('');
  placeholder: InputSignal<any> = input('');
  parentFormGroup: InputSignal<FormGroup<any>> = input(new FormGroup({}));
  controlName: InputSignal<any> = input('');
  error: InputSignal<any> = input('');
  suffixIcon: InputSignal<any> = input('');
  suffixSvgIcon: InputSignal<any> = input('');
  prefixIcon: InputSignal<any> = input('');
  prefixSvgIcon: InputSignal<any> = input('');
  hideSubscript: InputSignal<any> = input(false);
  maxLength: InputSignal<any> = input(9999999);
  checkForErrors: OutputEmitterRef<any> = output();
  handleSuffixClick: OutputEmitterRef<void> = output();
  handlePrefixClick: OutputEmitterRef<void> = output();

  fieldSubscription: Subscription | undefined;

  isRequired: boolean = false;
  isDisabled: boolean = false;


  // Do not show field as touched and having error when clicked outside the field
  @HostListener("focusout", ["$event"])
  onBlur() {
    if (!this.error()) {
      // @ts-ignore
      this.parentFormGroup()?.controls[this.controlName()].markAsUntouched();
    }
  }

  ngOnInit(): void {
    // @ts-ignore
    const control = this.parentFormGroup()?.controls[this.controlName()];

    this.isDisabled = control?.status === "DISABLED";
    this.fieldSubscription = control?.valueChanges?.subscribe(() => {
      // If field is marked as touched, mark it as untouched
      if (control?.touched) {
        control?.markAsUntouched();
      }

      // Get errors on the form field
      const errors = control?.errors;

      // If errors exist, handle it
      if (errors) {
        // Clear errors on the form field
        control?.setErrors(null);

        // Clear out the error messages on the screen (parent component)
        this.checkForErrors?.emit(this.controlName());

        // Add errors again to the form field for showing messages in the future
        control?.setErrors(errors);
      } else {
        // Clear out the error messages on the screen (parent component)
        this.checkForErrors?.emit(this.controlName());
      }
    });

    // Check if field is required
    if (control?.validator) {
      const validator = control.validator({} as AbstractControl);
      this.isRequired = !!(validator && validator["required"]);
    }
  }

  suffixClick() {
    this.handleSuffixClick.emit();
  }

  prefixClick() {
    this.handlePrefixClick.emit();
  }

  ngOnDestroy() {
    this.fieldSubscription?.unsubscribe();
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
